(function () {
    'use strict';

    angular
     .module('oddCampaignRespondentModule')
     .controller('oddCampaignRespondentListController', Controller);

    Controller.$inject = ['$scope', '$state', 'pagerService', '$modal', 'oddCampaignRespondentService', 'notificationService', 'modalService', 'oddSurveyService'];

    function Controller($scope, $state, pagerService, $modal, campaignRespondentService, notificationService, modalService, oddSurveyService) {

        // Get surveyV2 lookups
        oddSurveyService
            .getLookups()
            .then(function (lkups) {
                $scope.surveyLookups = lkups;
            });

        var unregisterWatchRespondents = undefined;

        $scope.pager = pagerService.newPager({
            numberOfItemsPerPage: 16
        });
        $scope.pager.updatePagerFromItems($scope.boxModel);
        $scope.respondents = $scope.boxModel;
        $scope.view = {
            isMultiSelect: false
        };
        $scope.filteredRespondents = [];
        watchRespondents();
        // TODO: All logic to add respondents should be provided by the page controller

        $scope.getStatusCount = function (status) {
            return _.filter($scope.respondents, {
                RespondentStatus: status
            }).length;
        }

        $scope.toggleMultiSelection = function () {
            $scope.view.isMultiSelect = !$scope.view.isMultiSelect;
        };

        $scope.selectAllRespondents = function () {
            _.forEach($scope.boxModel, function (respondent) {
                respondent.isSelected = $scope.isSelectable(respondent);
            });
        };

        $scope.unselectAllRespondents = function () {
            _.forEach($scope.boxModel, function (respondent) {
                respondent.isSelected = false;
            });
        };

        $scope.addPSPEmployee = function () {
            // Modal to select Owner
            var modalScope = $scope.$new(true);
            modalScope.actualRespondents = $scope.respondents;

            var selectNewRespondentModal = $modal({
                scope: modalScope,
                template: '/app/Main/survey/campaign/selectNewRespondentModal.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                selectNewRespondentModal.$promise.then(selectNewRespondentModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            };

            // Add the selected respondent
            modalScope.addRespondent = function (selectedEmployee) {
                campaignRespondentService
                 .addCampaignRespondent($scope.boxContext.campaign.ODDBusinessUnitID, $scope.boxContext.campaign.ODDCampaignID, selectedEmployee)
                 .then(function (newRespondentEmployeeObject) {
                     notificationService.notify('1 new respondent added successfully');
                     $scope.boxModel = newRespondentEmployeeObject;
                     $scope.pager.updatePagerFromItems($scope.boxModel);
                 })
                 .finally(function () {
                     modalScope.hideModal();
                     $state.reload();
                 });
            };

            // Add the selected respondent with its subordinates
            modalScope.addRespondentWithSubordinates = function (selectedEmployee) {
                campaignRespondentService
                 .addRespondentWithSubordinates($scope.boxContext.campaign.ODDBusinessUnitID, $scope.boxContext.campaign.ODDCampaignID, selectedEmployee)
                 .then(function (addedRespondents) {
                     var nbNewRespondents = addedRespondents.length - $scope.boxModel.length,
                      successMessage;

                     if (nbNewRespondents === 0) {
                         successMessage = "All the respondents are already in the list."
                     } else if (nbNewRespondents === 1) {
                         successMessage = '1 new respondent added successfully.'
                     } else {
                         successMessage = nbNewRespondents + ' new respondents added successfully';
                     }
                     notificationService.notify(successMessage);
                     $scope.boxModel = addedRespondents;

                     $scope.pager.updatePagerFromItems($scope.boxModel);
                 })
                 .finally(function () {
                     modalScope.hideModal();
                     $state.reload();
                 });
            };
        };

        $scope.addExternalRespondent = function () {
            modalService.displayTemplateModal(
             '<i class="fa fa-user govBox-icon margin-sm-right"></i> Create External Respondent',
             require('../../../Main/odd/surveyCampaigns/oddExternalRespondentModal.tpl.html'), {
                 okText: 'Create',
                 respondent: {},
                 campaign: $scope.boxContext.campaign
             },
             externalRespondentCreated);
        };

        $scope.sendReminderToAllSelected = function () {
            var selectedResp = _.filter($scope.boxModel, 'isSelected');

            if (selectedResp.length > 0) {
                $scope
                 .sendReminder(selectedResp)
                 .then(function () {
                     notificationService.notify('All selected respondents should receive an invitation soon');
                 });
            }
        };

        $scope.isSelectable = function (respondent) {
            return respondent.RespondentStatus === 'NotStarted' || respondent.RespondentStatus === 'InProgress';
        }

        $scope.updateStatus = function (status) {
            $scope.status = status;
            updateFilteredRespondents();
        }

        function destroy() {
            if (unregisterWatchRespondents) unregisterWatchRespondents();
            $scope.filteredRespondents.length = 0;
            $scope.pager = undefined;
        }

        function watchRespondents() {
            if (unregisterWatchRespondents) unregisterWatchRespondents();
            unregisterWatchRespondents = $scope.$watch('respondents', function (newVal, oldVal) {
                updateFilteredRespondents();
            }, true);
        }

        function isSomeRespondentsSelected() {
            return _.some($scope.respondents, {
                isSelected: true
            });
        }

        function externalRespondentCreated(modalScope, form) {
            if (form.$valid) {
                campaignRespondentService
                 .addCampaignRespondent($scope.boxContext.campaign.ODDBusinessUnitID, $scope.boxContext.campaign.ODDCampaignID, modalScope.respondent)
                 .then(function (newRespondentEmployeeObject) {
                     notificationService.notify('1 new respondent added successfully');
                     $scope.boxModel = newRespondentEmployeeObject;
                     $scope.pager.updatePagerFromItems($scope.boxModel);
                 })
                 .finally(function () {
                     $state.reload();
                 });
            }
            return form.$valid;
        }

        function updateSearch(search) {
            $scope.search = search;
            updateFilteredRespondents();
        }

        function updateFilteredRespondents() {
            $scope.filteredRespondents.length = 0;
            var filteredRespondents = getFilteredRespondents();

            _.forEach(filteredRespondents, function (respondent) {
                $scope.filteredRespondents.push(respondent);
            });

            $scope.pager.updatePagerFromItems($scope.filteredRespondents);
        }

        function getFilteredRespondents() {
            if (!$scope.status) return $scope.respondents;
            var filteredByStatus = $scope.respondents;
            if ($scope.status) filteredByStatus = _.filter(filteredByStatus, {
                RespondentStatus: $scope.status
            });
            return filteredByStatus;
        }
    }
})();
